import React, { Component } from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import some from 'lodash/some';
import { SimplePagination } from '../../SimplePagination';
import './FreelancerProfilePopup.css';
import { Thumbnail } from '../../Thumbnail';
import { FreelancerProfileCard } from '../../FreelancerProfileCard/FreelancerProfileCard';

export class FreelancerProfilePopup extends Component {
  state = {
    portfolioIndex: 0,
    experienceIndex: 0,
  };

  getPortfoliosView = () => {
    const { portfolioIndex } = this.state;
    const { freelancer } = this.props;
    if (isEmpty(freelancer.submissions)) return null;

    const {
      video_link: portfolioVideoLink,
      clip_name: portfolioClipName,
      skills: portfolioSkills,
      contribution_level: portfolioContributionLevel,
      comments: portfolioComments,
    } = freelancer.submissions[portfolioIndex];

    return (
      <div>
        <div className="freelancer-profile-popup__portfolio-header">
          <div className="freelancer-profile-popup__portfolio-title">
            Portfolio
          </div>
          <div>
            <SimplePagination
              total={freelancer.submissions.length}
              onChange={currentPage =>
                this.setState({ portfolioIndex: currentPage - 1 })
              }
            />
          </div>
        </div>
        <div className="freelancer-profile-popup__portfolio-card">
          <Thumbnail
            src={portfolioVideoLink}
            alt="video thumbnail"
            className="freelancer-profile-popup__portfolio-card-image"
            defaultSrc="https://i.vimeocdn.com/video/674803523.jpg?mw=344&mh=194"
            defaultVideoSrc="https://i.vimeocdn.com/video/674803523.jpg?mw=344&mh=194"
          />
          <div className="freelancer-profile-popup__portfolio-card-title">
            {portfolioClipName}
          </div>
          <div className="freelancer-profile-popup__portfolio-card-subtitle">
            {map(portfolioSkills, (skill, index) => (
              <span key={String(index)}>
                {skill}
                {portfolioSkills.length - 1 > index && ', '}
              </span>
            ))}
            <span> | </span>
            <i>{portfolioContributionLevel}</i>
          </div>
          <div className="freelancer-profile-popup__portfolio-card-description">
            {portfolioComments}
          </div>
        </div>
      </div>
    );
  };

  getExperiencesView = () => {
    const { experienceIndex } = this.state;
    const { freelancer } = this.props;
    if (isEmpty(freelancer.experiences)) return null;

    const {
      job_title: experienceJobTitle,
      job_description: experienceDescription,
      company_name: experienceCompanyName,
    } = freelancer.experiences[experienceIndex];

    return (
      <div>
        <div className="freelancer-profile-popup__portfolio-header">
          <div className="freelancer-profile-popup__portfolio-title">
            Experiences
          </div>
          <div>
            <SimplePagination
              total={freelancer.experiences.length}
              onChange={currentPage =>
                this.setState({ experienceIndex: currentPage - 1 })
              }
            />
          </div>
        </div>
        <div className="freelancer-profile-popup__experience-card">
          <div className="freelancer-profile-popup__experience-card-title">
            {experienceJobTitle}, {experienceCompanyName}
          </div>
          <div className="freelancer-profile-popup__experience-card-description">
            {experienceDescription}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      projectId,
      freelancer,
      fetchFreelancers,
      handleBookNow,
      handleRequestABid,
      handleDeleteABid,
      dispatchCloseDialog,
      acceptFreelancerBid,
      bid,
    } = this.props;
    const bidRequested = some(freelancer.bids, {
      project_id: projectId,
    });

    const bidAction = () => {
      dispatchCloseDialog();
      if (bid) {
        return acceptFreelancerBid(bid.id);
      }

      if (!bidRequested) {
        return handleRequestABid(freelancer, fetchFreelancers);
      }
      return handleDeleteABid(freelancer, fetchFreelancers);
    };

    return (
      <div className="freelancer-profile-popup">
        <div className="freelancer-profile-popup__left-column">
          <FreelancerProfileCard
            bidAction={bidAction}
            bidRequested={bidRequested}
            freelancer={freelancer}
            handleBookNow={handleBookNow}
            bidding={!freelancer.accepting}
            bid={bid}
          />
          <div className="freelancer-profile-popup__freelancers-skills">
            <div className="freelancer-profile-popup__freelancers-skills-title">
              Skills
            </div>

            <div className="freelancer-profile-popup__freelancers-skills-item-label">
              {!isEmpty(freelancer.preProductionDescriptions) &&
                'Pre-Production'}
            </div>
            <div className="freelancer-profile-popup__freelancers-skills-item-value-container">
              {map(freelancer.preProductionDescriptions, (skill, index) => (
                <div
                  key={String(index)}
                  className="freelancer-profile-popup__freelancers-skills-item-value-block"
                >
                  <span
                    className="freelancer-profile-popup__freelancers-skills-item-value"
                    key={String(index)}
                  >
                    {skill}
                  </span>
                </div>
              ))}
            </div>

            <div className="freelancer-profile-popup__freelancers-skills-item-label">
              {!isEmpty(freelancer.productionDescriptions) && 'Production'}
            </div>
            <div className="freelancer-profile-popup__freelancers-skills-item-value-container">
              {map(freelancer.productionDescriptions, (skill, index) => (
                <div
                  key={String(index)}
                  className="freelancer-profile-popup__freelancers-skills-item-value-block"
                >
                  <span
                    className="freelancer-profile-popup__freelancers-skills-item-value"
                    key={String(index)}
                  >
                    {skill}
                  </span>
                </div>
              ))}
            </div>

            <div className="freelancer-profile-popup__freelancers-skills-item-label">
              {!isEmpty(freelancer.animationDescriptions) && 'Animation'}
            </div>
            <div className="freelancer-profile-popup__freelancers-skills-item-value-container">
              {map(freelancer.animationDescriptions, (skill, index) => (
                <div
                  key={String(index)}
                  className="freelancer-profile-popup__freelancers-skills-item-value-block"
                >
                  <span className="freelancer-profile-popup__freelancers-skills-item-value">
                    {skill}
                  </span>
                </div>
              ))}
            </div>

            <div className="freelancer-profile-popup__freelancers-skills-item-label">
              {!isEmpty(freelancer.videoEditingDescriptions) &&
                'Software Specialization'}
            </div>
            <div className="freelancer-profile-popup__freelancers-skills-item-value-container">
              {map(freelancer.videoEditingDescriptions, (skill, index) => (
                <div
                  key={String(index)}
                  className="freelancer-profile-popup__freelancers-skills-item-value-block"
                >
                  <span className="freelancer-profile-popup__freelancers-skills-item-value">
                    {skill}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="freelancer-profile-popup__right-column">
          {this.getPortfoliosView()}

          {this.getExperiencesView()}
        </div>
      </div>
    );
  }
}

FreelancerProfilePopup.propTypes = {
  projectId: PropTypes.number,
  freelancer: PropTypes.object,
  dispatchCloseDialog: PropTypes.func.isRequired,
  fetchFreelancers: PropTypes.func,
  handleBookNow: PropTypes.func,
  handleRequestABid: PropTypes.func.isRequired,
  handleDeleteABid: PropTypes.func,
  acceptFreelancerBid: PropTypes.func,
  bid: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/Popup/FreelancerProfilePopup/FreelancerProfilePopup.js